var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWont = function SvgWont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.43 12.989V1.637c0-.43.286-.81.62-.81h5.533V13.8H1.05c-.334 0-.62-.334-.62-.811Z",
    fill: "#921A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.227 15.421h-6.534v4.913a3.247 3.247 0 0 1-3.243 3.244h-2.433a.836.836 0 0 1-.81-.811v-3.864l-3.149-5.485c-.095-.143-.095-.238-.095-.381v-11.4c0-.43.381-.81.81-.81h13.07c1.287 0 2.432.762 2.957 1.907l2.623 5.867a.884.884 0 0 1 .096.334v3.243c-.048 1.813-1.527 3.243-3.292 3.243Z",
    fill: "#B75B5B"
  })));
};

export default SvgWont;